/**
 * Dependencies
 */
import http from './HttpService'

/**
 * Get the project invitation data
 *
 * @return {Promise}
 */
export const getInvitationList = () => {
    return http.get('projects/invitations/')
}

/**
 * Get the sent invitaton list
 *
 * @return {Promise}
 */
export const getSentInvitationList = () => {
    return http.get('projects/collaborate')
}

/**
 * API call to accept invite
 *
 * @param  {Number} id
 * @return {Promise}
 */
export const acceptProjectInvite = (id) => {
    return http.put(`projects/invitations/${id}`)
}

/**
 * API call to accept invite
 *
 * @param  {Number} id
 * @return {Promise}
 */
export const rejectProjectInvite = (id) => {
    return http.del(`projects/invitations/${id}`)
}

/**
 * Update an invitation privilege level
 *
 * @param  {Object} payload
 * @return {Promise}
 */
export const updatePrivilege = (payload) => {
    return http.patch(`projects/collaborate/${payload.id}`, {
        privilege_level: payload.level
    })
}

/**
 * Delete a sent invitation
 *
 * @param  {Number} id
 * @return {Promise}
 */
export const removeInvite = (id) => {
    return http.del(`projects/collaborate/${id}`)
}

/**
 * Get the CA for a given invite
 *
 * @param  {Number} id
 * @return {Promise}
 */
export const getConfidentialityAgreement = (id) => {
    return http.get(`projects/invitations/${id}`)
}

/**
 * Accept the CA and invitation
 *
 * @param  {Number} id
 * @return {Promise}
 */
export const acceptAgreementAndInvitation = (id) => {
    return http.post(`projects/invitations/${id}`, {
        accepts_ca: true
    })
}



// WEBPACK FOOTER //
// ./src/services/InvitationService.js